// extracted by mini-css-extract-plugin
export default {"errorPanel":"uf3P4UCJrZTQmuLo_9DJv"};